export default __webpack_public_path__ + "static/media/icon-font.b3b7d8a5.ttf";